import React, { PureComponent } from 'react'

import AuthContext from '../../main/authenticationProvider'
import DashboardService from '../../app/service/dashboardService'
import RouteService from '../../app/service/routeService'
import PlateService from '../../app/service/plateService'
import { Map, InfoWindow, Marker, GoogleApiWrapper, Polyline } from 'google-maps-react';
import Moment from 'moment';
import DecodePolyline from 'decode-google-map-polyline';
import caminhao from "../../assets/images/caminhao.png";
import marker_icon_start from "../../assets/images/route_flag_start.png";
import marker_icon_end from "../../assets/images/route_flag_end.png";
import marker_icon_route_in from "../../assets/images/route_in.png";
import marker_icon_route_out from "../../assets/images/route_out.png";
import Loading from "../../components/loading";
import { messageAlert } from '../../components/toastr';
import AppLayout from '../../components/layouts/AppLayout';
import './home.css';
import '../../views/custom-components.css'
import { Row, Col, Table, Card, Badge, Select } from 'antd';
import styles from './home.module.scss';

const TIME_FETCH_DATA = 60000;

// rota: 1 -> (cinza e cinza vazio) não esta em rota
// rota: 2 -> (vermelho e vermelho) no momento está fora de rota
// rota: 3 -> (verde e vermelho) no passado esteve fora, mas no momento está OK
// rota: 4 -> (verde e verde) até o presente momento tudo OK

const columns = [
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Status Atual</div>
        },
        dataIndex: 'trackerStatus',
        key: 'trackerStatus',
        align: 'center',
        render: (_, data) => {
            if (data.trackerStatus !== undefined) {
                return data.trackerStatus === 4 ? <>
                    <i className="pi pi-check-circle inRouteIcon"></i>
                </> : data.trackerStatus === 3 ? <>
                    <i className="pi pi-check-circle inRouteIcon"></i>
                </> : data.trackerStatus === 2 ? <>
                    <i className="pi pi-times-circle outRouteIcon"></i>
                </> : data.trackerStatus === 1 && data.routeStartStatus === "STARTED" ? <>
                    <i className="pi pi-circle-on noRouteIconAndStarted"></i>
                </> : <>
                    <i className="pi pi-ban noRouteIcon"></i>
                </>
            }
        },

        width: 100
    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Status Prévio</div>
        },
        dataIndex: 'trackerStatus',
        key: 'trackerStatus',
        align: 'center',
        render: (_, data) => {
            if (data.trackerStatus !== undefined) {
                return data.trackerStatus === 4 ? <>
                    <i className="pi pi-check-circle inRouteIcon"></i>
                </> : data.trackerStatus === 3 ? <>
                    <i className="pi pi-times-circle outRouteIcon"></i>
                </> : data.trackerStatus === 2 ? <>
                    <i className="pi pi-times-circle outRouteIcon"></i>
                </> : data.trackerStatus === 1 && data.routeStartStatus === "STARTED" ? <>
                    <i className="pi pi-circle-on noRouteIconAndStarted"></i>
                </> : <>
                    <i className="pi pi-ban noRouteIcon"></i>
                </>
            }
        },

        width: 100
    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Placa</div>
        },
        dataIndex: 'plate',
        key: 'plate',
        align: 'center',
        width: 80,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },
    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Ignição</div>
        },
        dataIndex: 'ignition',
        key: 'ignition',
        align: 'center',
        width: 80,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },

    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Data/Hora</div>
        },
        dataIndex: 'date',
        key: 'date',
        align: 'center',
        render: (row) => {
            const dataTime = row && Moment(row).format('DD/MM/YYYY HH:mm:ss')
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{dataTime}</div>
            );
        },
        width: 150,

    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Velocidade [km/h]</div>
        },
        dataIndex: 'speed',
        key: 'speed',
        align: 'center',
        width: 128,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },

    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Latitude</div>
        },
        dataIndex: 'latitude',
        key: 'latitude',
        align: 'center',
        width: 90,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },

    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Longitude</div>
        },
        dataIndex: 'longitude',
        key: 'longitude',
        align: 'center',
        width: 90,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },

    },
    {
        title: () => {
            return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Endereço</div>
        },
        dataIndex: 'address',
        key: 'address',
        align: 'center',
        width: 490,
        render: (row) => {
            return (
                <div style={{ alignContent: 'center', fontSize: '12px', fontWeight: 400 }}>{row}</div>
            );
        },

    },
];

class Home extends PureComponent {
    constructor(props) {
        super(props);
        this.serviceDashboard = new DashboardService();
        this.serviceRoute = new RouteService();
        this.servicePlate = new PlateService();
        this.auth = new AuthContext();
        this.state = {
            markers: [],
            showingInfoWindow: false,
            showingTrackInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            showLoading: true,
            selectedRows: [],
            latitude: -15.7801,
            longitude: -47.9292,
            zoom: 4,
            routeSelected: null,
            triangleCoords: null,
            tracks: null,
            selectedTrack: {},
            loading: false,
            plateName: "",
            tablePageSize: 5,
            currentPage: 1,
            totalRegisters: 0,
            plates: [],
        }
    }


    onMarkerClick = (props, marker) => {
        this.setState({
            activeMarker: marker,
            selectedPlace: props.information,
            showingInfoWindow: true
        });
    }

    onMarkerTrackClick = (props, marker) => {
        this.setState({
            activeMarker: marker,

        }, () => {
            this.setState({
                selectedTrack: props.information,
                showingTrackInfoWindow: true
            })
        });
    }

    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            showingInfoWindow: false,
            showingTrackInfoWindow: false
        });
    }

    interval = null;

    getIndex = (value, arr, prop) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }

    getData = (plateName, tablePageSize, currentPage) => {
        this.setState({
            showLoading: true
        });

        let options = [];
        let markers = []
        this.serviceDashboard
            .getDashboardInformation(plateName, tablePageSize, currentPage)
            .then(response => {
                response.data.data.forEach((element, index) => {
                    options.push({
                        key: index,
                        value: element.plate,
                        label: element.plate
                    });
                    markers.push({
                        key: index,
                        address: element.address,
                        date: element.date,
                        deviceId: element.deviceId,
                        direction: element.direction,
                        driverId: element.driverId,
                        driverName: element.driverName,
                        horimeter: element.horimeter,
                        ignition: element.ignition,
                        latitude: element.latitude,
                        longitude: element.longitude,
                        mainBattery: element.mainBattery,
                        messageStatus: element.messageStatus,
                        odometer: element.odometer,
                        plate: element.plate,
                        plateId: element.plateId,
                        positionId: element.positionId,
                        routeId: element.routeId,
                        speed: element.speed,
                        trackerStatus: element.trackerStatus,
                    })
                });

                let promises = markers.map((element, index) => {
                    return this.servicePlate.getStatusRoutePlate(element.plate).then((response) => {
                        if (response.status === 404) {

                        }
                        return {
                            ...element,
                            key: index,
                            routeStartStatus: response.data.data.routeStartStatus,
                            routeLoadStatus: response.data.data.routeLoadStatus,
                        }

                    }).catch((e) => {
                        return null;
                    })
                }).filter(promise => promise !== null);
                Promise.all(promises).then((results) => {

                    const finalList = results.filter((result) => result !== null);

                    this.setState({
                        markers: finalList.length > 0 ? finalList : markers,
                        totalRegisters: response.data.totalRegisters,
                        showLoading: false,
                        plates: options,
                    });
                });

                if (this.state.selectedRows.length > 0) {
                    let index = this.getIndex(this.state.selectedRows[0].plateId, response.data.data, "plateId");
                    if (index !== -1 && response.data.data[index].trackerStatus !== 1) {
                        this.getRoute();
                    } else {
                        this.setState({
                            selectedRows: [],
                            tracks: null,
                            routeSelected: null,
                            triangleCoords: null,
                        });
                    }
                }
            })
            .catch(erros => {
                this.setState({
                    showLoading: false,
                    markers: [],
                    totalRegisters: 0,
                });
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
            });
    }
    getRoute = row => {
        let plateId = row && row.plateId ? row.plateId : this.state.selectedRows[0].plateId;
        let routeId = row && row.routeId ? row.routeId : this.state.selectedRows[0].routeId;

        this.setState({
            loading: true,
        });

        this.serviceRoute
            .getRouteInformationByVehicle(routeId)
            .then(response => {
                // clear
                // ploter

                this.setState({
                    routeSelected: response.data.data,
                    triangleCoords: response.data.data.polyline ? DecodePolyline(response.data.data.polyline) : null,
                    latitude: row.latitude ? row.latitude : this.state.selectedRows[0].latitude,
                    longitude: row.longitude ? row.longitude : this.state.selectedRows[0].longitude,
                    zoom: 12,
                    loading: false,
                });
            })
            .catch(erros => {
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
                this.setState({
                    loading: false,
                });
            })

        this.servicePlate
            .getTracks(plateId)
            .then(response => {
                this.setState({
                    tracks: response.data.data,
                });
            })
            .catch(erros => {
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
            })
    }

    handleRowClicked = row => {
        if (row !== undefined && row.routeId) {
            if (this.state.selectedRows.length <= 0 || this.state.selectedRows[0] !== undefined && row.plate !== this.state.selectedRows[0].plate) {
                const arraySelectedRow = [];
                arraySelectedRow.push(row);
                this.setState({
                    selectedRows: arraySelectedRow
                });
                this.getRoute(row);
            }
        } else {
            this.setState({
                selectedRows: [],
                tracks: null,
                routeSelected: null,
                triangleCoords: null,
            });
        }
    }

    delayOnChangeSearch = (plateName, currentPage) => {
        this.setState({
            showLoading: true
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.getData(plateName, this.state.tablePageSize, currentPage), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidMount() {
        this.getData(this.state.plateName, this.state.tablePageSize, this.state.currentPage);
        this.interval = setInterval(() => {
            this.getData(this.state.plateName, this.state.tablePageSize, this.state.currentPage);
        }, TIME_FETCH_DATA);
    }
    render() {
        /**
         * Table Pagination config
         */
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            //showSizeChanger: true,
            //pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                this.getData(this.state.plateName, pageSize, page);
            },
        }
        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;
        return (
            <>
                <AppLayout >
                    {this.state.loading && (
                        <Loading />
                    )}

                    <Row style={{ height: '100%' }}>
                        <Col span={24}>
                            {this.state.routeSelected && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        backgroundColor: 'white',
                                        //padding: '15px'
                                    }}
                                >
                                    <b>{this.state.routeSelected.name}</b>
                                    {this.state.selectedRows.trackerStatus === 3 ?
                                        (<Badge status="error" text="Rota já violada pelo veículo." />) :
                                        (<Badge status="success" text="Rota não violada pelo veículo." />)}
                                </div>
                            )}
                            <div style={{ width: '100%', height: '45vh' }}>
                                <Map
                                    mapId={'map'}
                                    google={this.props.google}
                                    zoom={this.state.zoom}
                                    zoomControl={true}
                                    zoomControlOptions={{
                                        style: window.google.maps.ZoomControlStyle.SMALL,
                                        position: window.google.maps.ControlPosition.RIGHT_BOTTOM
                                    }}
                                    scrollwheel={true}
                                    scaleControl={true}
                                    streetViewControl={true}
                                    streetViewControlOptions={{
                                        position: window.google.maps.ControlPosition.RIGHT_BOTTOM
                                    }}
                                    panControl={true}
                                    mapTypeControl={true}
                                    initialCenter={{ lat: -15.7801, lng: -47.9292 }}
                                    center={{ lat: this.state.latitude, lng: this.state.longitude }}
                                >


                                    {this.state.triangleCoords !== null && (
                                        <Polyline
                                            path={this.state.triangleCoords}
                                            strokeColor="#0000FF"
                                            strokeOpacity={1.8}
                                            strokeWeight={2}
                                        />
                                    )}

                                    {this.state.routeSelected !== null && this.state.routeSelected.origin && (
                                        <Marker
                                            key="marker-origin"
                                            title={this.state.routeSelected.origDescr}
                                            position={{ lat: this.state.routeSelected.origin[1], lng: this.state.routeSelected.origin[0] }}
                                            icon={{
                                                url: marker_icon_start,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 31),
                                                scaledSize: new window.google.maps.Size(31, 31)
                                            }}
                                        />
                                    )}

                                    {this.state.routeSelected !== null && this.state.routeSelected.destination && (

                                        <Marker
                                            key="marker-destination"
                                            title={this.state.routeSelected.destDescr}
                                            position={{ lat: this.state.routeSelected.destination[1], lng: this.state.routeSelected.destination[0] }}
                                            icon={{
                                                url: marker_icon_end,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 31),
                                                scaledSize: new window.google.maps.Size(31, 31)
                                            }}
                                        />
                                    )}

                                    {this.state.tracks !== null && this.state.tracks.map((track, i) => {
                                        return <Marker
                                            key={`track-${i + 1}`}
                                            title={Moment(track.date).format('DD/MM/YYYY HH:mm:ss')}
                                            information={track}
                                            position={{ lat: track.location[1], lng: track.location[0] }}
                                            // onClick={this.onMarkerTrackClick}
                                            icon={{
                                                url: track.inroute ? marker_icon_route_in : marker_icon_route_out,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 10),
                                                scaledSize: new window.google.maps.Size(10, 10)
                                            }}
                                        />
                                    })}

                                    {this.state.selectedRows.length <= 0 && this.state.markers.length > 0 && this.state.markers.map((place, i) => {
                                        return <Marker
                                            key={`marker-${i + 1}`}
                                            label={{
                                                className: styles.labelMap,
                                                text: place.plate,
                                                fontFamily: "Arial",
                                                fontSize: "14px",
                                                color: "white",

                                            }}
                                            title={place.plate}
                                            information={place}
                                            position={{ lat: place.latitude, lng: place.longitude }}
                                            onClick={this.onMarkerClick}
                                            icon={{
                                                url: caminhao,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 35),
                                                scaledSize: new window.google.maps.Size(35, 35),
                                                labelOrigin: new window.google.maps.Point(20, -15),
                                            }}
                                        />
                                    })}

                                    {this.state.selectedRows.length > 0 && this.state.markers.length > 0 && this.state.markers.filter(place => place.plate === this.state.selectedRows[0].plate).map((place, i) => {
                                        return <Marker
                                            key={`marker-${i + 1}`}
                                            label={{
                                                className: styles.labelMap,
                                                text: place.plate,
                                                fontFamily: "Arial",
                                                fontSize: "14px",
                                                color: "white",

                                            }}
                                            title={place.plate}
                                            information={place}
                                            position={{ lat: place.latitude, lng: place.longitude }}
                                            onClick={this.onMarkerClick}
                                            icon={{
                                                url: caminhao,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 35),
                                                scaledSize: new window.google.maps.Size(35, 35),
                                                labelOrigin: new window.google.maps.Point(20, -15),
                                            }}
                                        />
                                    })}

                                    {this.state.markers.length > 0 && this.state.markers.filter(place => place.trackerStatus === 2).map((place, i) => {
                                        return messageAlert("ATENÇÃO! Veículo placa " + place.plate + " com rota violada.")
                                    })}

                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingInfoWindow}
                                    >
                                        <div>
                                            <h5>Informações Adicionais</h5>
                                            <p><b>Placa: </b>{this.state.selectedPlace.plate}</p>
                                            <p><b>Dispositivo: </b>{this.state.selectedPlace.deviceId}</p>
                                            <p><b>Odômetro: </b>{this.state.selectedPlace.odometer}</p>
                                            <p><b>Horimetro: </b>{this.state.selectedPlace.horimeter}</p>
                                            <p><b>Bateria Principal: </b>{this.state.selectedPlace.mainBattery}</p>
                                            <p><b>Velocidade: </b>{this.state.selectedPlace.speed}</p>
                                            <p><b>Motorista: </b>{this.state.selectedPlace.driverName}</p>
                                        </div>
                                    </InfoWindow>

                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingTrackInfoWindow}
                                    >
                                        <div>
                                            <h5>Informações Adicionais</h5>
                                            <p><b>Latitude: </b>{this.state.selectedTrack && this.state.selectedTrack.location && this.state.selectedTrack.location.length > 0 ? this.state.selectedTrack.location[1] : ''}</p>
                                            <p><b>Longitude: </b>{this.state.selectedTrack && this.state.selectedTrack.location && this.state.selectedTrack.location.length > 0 ? this.state.selectedTrack.location[0] : ''}</p>
                                            <p><b>Date: </b>{Moment(this.state.selectedTrack.date).format('DD/MM/YYYY HH:mm:ss')}</p>
                                            <p><b>Status: </b>{this.state.selectedTrack.inroute ? 'Dentro da rota' : 'Fora da rota'}</p>
                                        </div>
                                    </InfoWindow>
                                </Map>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Card bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }} style={{ height: '100%' }}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={e => {
                                        this.setState({ plateName: e, currentPage: 1 });

                                        this.delayOnChangeSearch(e, 1);
                                    }}
                                    placeholder="Pesquisar por placa"
                                    options={this.state.plates ? this.state.plates : null}
                                    size='small'
                                    style={{ marginBottom: '5px', width: '30%', height: '100%' }}
                                />
                                <Table
                                    pagination={paginationTable}
                                    size='small'
                                    scroll={{ x: "max-content" }}
                                    style={{ width: '100%', height: '100%' }}
                                    columns={columns}
                                    dataSource={this.state.markers}
                                    loading={this.state.showLoading}
                                    rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                    onRow={(record) => {
                                        return {
                                            onClick: () => {
                                                this.handleRowClicked(record)
                                            }
                                        };
                                    }}
                                />
                            </Card>
                        </Col>


                    </Row>
                </AppLayout>
            </>
        );
    }
}

// Tata
export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_API_KY_GOOGLE_MAPS,
    LoadingContainer: () => <Loading />
})(Home);